import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CounterCard from './CounterCard';
import { DownloadIcon2x } from '../../../components/Icons/DownloadIcon';
import { LoadingIconCard } from '../../../components/Icons/LoadingIcon';
import { SuccessTickIconCard } from '../../../components/Icons/SuccessTickIcon';
import { ErrorExclamationIconCard } from '../../../components/Icons/ErrorExclamationIcon';
import { TransactionsCounters } from '../../../models/TransactionsModels';

interface TransactionCountersProps {
  counters: TransactionsCounters;
  isLoading: boolean;
}

function TransactionCounters({ counters, isLoading }: TransactionCountersProps) {
  const [t] = useTranslation();

  return (
    <Grid container columnSpacing="1.5rem" sx={{ padding: '0' }}>
      {/* Submitted */}
      <CounterCard
        key="submitted"
        label={t('pages.transactions.cards.submitted')}
        value={counters.submitted}
        icon={<DownloadIcon2x />}
        isLoading={isLoading}
      />

      {/* Processing */}
      <CounterCard
        key="processing"
        label={t('pages.transactions.cards.processing')}
        value={counters.processing}
        icon={<LoadingIconCard />}
        isLoading={isLoading}
      />

      {/* Completed */}
      <CounterCard
        key="completed"
        label={t('pages.transactions.cards.completed')}
        value={counters.completed}
        icon={<SuccessTickIconCard />}
        isLoading={isLoading}
      />

      {/* Errors */}
      <CounterCard
        key="error"
        label={t('pages.transactions.cards.errors')}
        value={counters.error}
        icon={<ErrorExclamationIconCard />}
        isLoading={isLoading}
      />
    </Grid>
  );
}

export default TransactionCounters;
